var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhase3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.244,
    height: 80.955,
    viewBox: "0 0 82.244 80.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "conversation",
    transform: "translate(0 -4.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5642",
    "data-name": "Group 5642",
    transform: "translate(0 4.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5641",
    "data-name": "Group 5641",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10218",
    "data-name": "Path 10218",
    d: "M81.947,67.916l-4.777-13.9a34.777,34.777,0,0,0-30.649-50A34.738,34.738,0,0,0,11.223,38.3,25.313,25.313,0,0,0,3.539,69.4L.249,78.975A4.524,4.524,0,0,0,4.51,84.966a4.554,4.554,0,0,0,1.482-.249l9.575-3.29A25.421,25.421,0,0,0,26.389,83.87h.04A25.276,25.276,0,0,0,46.867,73.477a34.848,34.848,0,0,0,14.355-3.514l13.9,4.777a5.412,5.412,0,0,0,1.76.3,5.377,5.377,0,0,0,5.063-7.12ZM26.429,78.975H26.4a20.473,20.473,0,0,1-9.509-2.36,2.449,2.449,0,0,0-1.94-.151L5.13,79.837,8.5,70.019a2.448,2.448,0,0,0-.151-1.94,20.411,20.411,0,0,1,3.327-23.664A34.872,34.872,0,0,0,40.748,73.1,20.358,20.358,0,0,1,26.429,78.975ZM77.2,70a.444.444,0,0,1-.49.113L61.832,65a2.447,2.447,0,0,0-1.94.151,29.9,29.9,0,0,1-13.886,3.447H45.96A29.962,29.962,0,0,1,16.118,39.235,29.844,29.844,0,0,1,46.444,8.91,29.852,29.852,0,0,1,72.355,52.684a2.448,2.448,0,0,0-.151,1.94l5.114,14.882A.444.444,0,0,1,77.2,70Z",
    transform: "translate(0 -4.011)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5644",
    "data-name": "Group 5644",
    transform: "translate(28.929 25.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5643",
    "data-name": "Group 5643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10219",
    "data-name": "Path 10219",
    d: "M211.706,139.512H182.542a2.448,2.448,0,0,0,0,4.9h29.164a2.448,2.448,0,0,0,0-4.9Z",
    transform: "translate(-180.094 -139.512)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5646",
    "data-name": "Group 5646",
    transform: "translate(28.929 35.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5645",
    "data-name": "Group 5645",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10220",
    "data-name": "Path 10220",
    d: "M211.706,202.183H182.542a2.448,2.448,0,1,0,0,4.9h29.164a2.448,2.448,0,1,0,0-4.9Z",
    transform: "translate(-180.094 -202.183)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5648",
    "data-name": "Group 5648",
    transform: "translate(28.929 45.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5647",
    "data-name": "Group 5647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10221",
    "data-name": "Path 10221",
    d: "M200.479,264.852H182.541a2.448,2.448,0,1,0,0,4.9h17.938a2.448,2.448,0,0,0,0-4.9Z",
    transform: "translate(-180.093 -264.852)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase3Icon);
export default __webpack_public_path__ + "static/media/phase3_icon.48398100.svg";
export { ForwardRef as ReactComponent };